export default "__VITE_PUBLIC_ASSET__67a20cb7__"